import { render } from "./ExpenseReceiptDetailTabShipping.vue?vue&type=template&id=7b13be96"
import script from "./ExpenseReceiptDetailTabShipping.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptDetailTabShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__